import "./App.css";
import React from "react";
import HomePage from "./pages/HomePage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AuctionPage from "./pages/AuctionPage";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import LoginUaePassPage from "./pages/LoginUaePassPage";
import LoginUaePassPageOTP from "./pages/LoginUaePassPageOTP";
import RegisterPage from "./pages/RegisterPage";
import AuctionDetailsPage from "./pages/AuctionDetailsPage";
import HorseProfile from "./pages/HorseProfile";
import BiddingPage from "./pages/BiddingPage";
import StudBookPage from "./pages/StudBookPage";
import OwnerProfile from "./pages/OwnerProfile";
import OwnerDetailsPage from "./pages/OwnerDetailsPage";
import HorseDetailsPage from "./pages/HorseDetailsPage";
import HorseMarket from "./pages/HorseMarket";
import HorseMarketProfile from "./pages/HorseMarketProfile";
import ForgetPasswordPage from "./pages/ForgetPasswordPage";
import SingleServicePage from "./pages/SingleServicePage";
import SinglePost from "./pages/SinglePost";
import AboutUs from "./pages/AboutUs";
import NewsPage from "./pages/NewsPage";
import HorseSupplies from "./pages/HorseSupplies";
import SingleSupplier from "./pages/SingleSupplier";
import SingleTransportCompany from "./pages/SingleTransportCompany";
import HorseTransportCompanies from "./pages/HorseTransportCompanies";
import EquestrianCentersClubs from "./pages/EquestrianCentersClubs";
import SingleEquestrianCentersClubs from "./pages/SingleEquestrianCentersClubs";
import ContactUs from "./pages/ContactUs";
import ServicesPage from "./pages/ServicesPage";
import OrgChartPage from "./pages/OrgChartPage";
import Shows from "./pages/Shows";
import ShowDetails from "./pages/ShowDetails";
import WahoConference from "./pages/WahoConference";
import ShowEntryCard from "./pages/ShowEntryCard";
import ScrollToTop from "./components/scroll-to-top";
import CalendarPage from "./pages/CalendarPage";
import ShowEntryDetails from "./pages/ShowEntryDetails";
import AddRegisterHorse from "./pages/AddRegisterHorse";
import ShowEntryConflict from "./pages/ShowEntryConflict";
import ShowEntryTotalRegisteredHorses from "./pages/ShowEntryTotalRegisteredHorses";
import ShowEntryParticipantsRequest from "./pages/ShowEntryParticipantsRequest";
import ShowEntrySubmissionSuccessful from "./pages/ShowEntrySubmissionSuccessful";
import GalleryPage from "./pages/GalleryPage";
import AlbumPage from "./pages/AlbumPage";
import WahoTrophy from "./pages/WahoTrophy";
import BookTable from "./pages/BookTable";
import ShowsCategories from "./pages/ShowsCategories";
import AuctionEntryCard from "./pages/AuctionEntryCard";
import Auctionentrytotalregisteredhorses from "./pages/AuctionEntryTotalRegisteredHorses";
import AuctionEntrySubmissionSuccessful from "./pages/AuctionEntrySubmissionSuccessful";
import BookingSubmissionSuccessful from "./pages/BookingSubmissionSuccessful";
import OpendBooking from "./pages/OpendBooking";
import RequestHorseOwnershipTransferSeller from "./pages/RequestHorseOwnershipTransferSeller";
import ServicesRequestsPaymentSuccessful from "./pages/ServicesRequestsPaymentSuccessful";
import ComingSoon from "./components/ComingSoon";
import SingleHospital from "./pages/SingleHospital";
import HorseHospitals from "./pages/HorseHospitals";
import CoursesPage from "./pages/CoursesPage";
import SponsersPage from "./pages/SponsersPage";
import SingleTermsAndConditionsShowPage from "./pages/SingleTermsAndConditionsShowPage";
import EducationalPage from "./pages/EducationalPage";
import AddOrganizerRequest from "./pages/AddOrganizerRequest";
import LiveStream from "./pages/LiveStream";
import RequestCoveringCertificate from "./pages/RequestCoveringCertificate";
import AwardPage from "./pages/AwardPage";
import { toast, ToastContainer } from "react-toastify";
import ShowCatalog from "./pages/ShowCatalog";
import RequestEmbryoOocyteTransferPermit from "./pages/RequestEmbryoOocyteTransferPermit";
import LiveBiddingScreen from "./pages/LiveBiddingScreen";
import HybridBiddingPage from "./pages/HybridBiddingPage";
import RequestEmbryoTransferRightPurchaceAgreement from "./pages/RequestEmbryoTransferRightPurchaceAgreement";
import RequestRegisteringNewArabianHorseFoal from "./pages/RequestRegisteringNewArabianHorseFoal";
import RequestForOwnedEAHSRegisteredHorsesCertificate from "./pages/RequestForOwnedEAHSRegisteredHorsesCertificate";
import RequestForRegistrationOfAnArabianHorseStud from "./pages/RequestForRegistrationOfAnArabianHorseStud";
import RequestToUpdateArabianHorseData from "./pages/RequestToUpdateArabianHorseData";
import PressCoverageRequest from "./pages/PressCoverageRequest";
import RequestToDeclarationOfArabianHorseDeath from "./pages/RequestToDeclarationOfArabianHorseDeath";
import InactiveHorseRegistrationRequest from "./pages/InactiveHorseRegistrationRequest";
import RequestToAddARacingNameForAnImportedArabianHorse from "./pages/RequestToAddARacingNameForAnImportedArabianHorse";
import ReqestForIssuingAnArabianHorsePassportDuplicateDamaged from "./pages/ReqestForIssuingAnArabianHorsePassportDuplicateDamaged";
import ImportHorseFrozenSemen from "./pages/ImportHorseFrozenSemen";
import OpenApp from "./pages/OpenApp";
import AddFoalHorse from "./pages/AddFoalHorse";
import ImportHorse from "./pages/ImportHorse";
import GeneticDisorderTesting from "./pages/GeneticDisorderTesting";
import JudgesPage from "./pages/JudgesPage";
import RequestSemenCertificate from "./pages/RequestSemenCertificate";
import ExportHorse from "./pages/ExportHorse";
import ShowParticipatePage from "./pages/showEntry/ShowParticipatePage";
import AddInternationalHorse from "./pages/showEntry/AddInternationalHorse";
import ShowEntryCheckoutPage from "./pages/showEntry/ShowEntryCheckoutPage";
import CoursesNewPage from "./pages/CoursesNewPage";
import CourseEnrollment from "./pages/CourseEnrollment";
import AuctionDetails from "./pages/auctionDetails/AuctionDetails";
import PresidentWord from "./pages/PresidentWord";
import CancelExportHorse from "./pages/CancelExportHorse";
import ExportHorseSemen from "./pages/ExportHorseSemen";
import LibraryPage from "./pages/EahsLibrary/LibraryPage.js";
import RoutesName from './RoutesName.js'
import { useLocation } from "react-router-dom/dist/index.js";
import AucitonEntryParticipate from "./pages/AuctionEntry/AuctionEntryParticipate/AucitonEntryParticipate.js";
import AuctionEntryCheckoutPage from "./pages/AuctionEntry/AuctionEntryCheckoutPage.js";
import CourseEnrollmentDate from "./pages/CourseEnrollmentDate.js";
import ChulibPage from "./pages/CholibShow/ChulibPage.js";
import PrivateRoute from "./PrivateRoute.js";
import OwnerServicesForm from "./pages/ownersServices/OwnerServicesForm.js";
import FontCompetitionPage from "./pages/fontCompetition/FontCompetitionPage.js";
import SemenMarketListPage from "./pages/seminMarket/Pages/SemenMarketListPage.js";
import SemenDetails from "./pages/seminMarket/Pages/SemenDetails.js";
import SemenCheckout from "./pages/seminMarket/Pages/SemenCheckout.js";
import DigitalCatalog from "./pages/DigitalCatalog.js";
function App() {
  const dismissAll = () => toast?.dismiss();
  const ShowsCategoriesID = process.env.REACT_APP_SHOWS_CATEFORIES_ID;
  const NoneEcahoShowsCategoriesID = process.env.REACT_APP_NONE_ECAHO_SHOWS_CATEFORIES_ID;

  const searchParams = new URLSearchParams(window.location.search);
   const lang = searchParams.has("eahsLang")
    ? searchParams.get("eahsLang")
    : searchParams.has("eahslang") ? searchParams.get("eahslang") : null;
  const currentLang = localStorage.getItem('eahsLang') ?? 'en';
  if (!!lang) {
    if (currentLang != lang) {
      localStorage.setItem('eahsLang', lang);
      window.location.reload();
    }
  }

  return (
    <Router>
      <ScrollToTop />
      <ToastContainer
        position="top-right"
        onClick={dismissAll}
        theme="colored"
        autoClose={5000}
      />
      <Layout>
        <Routes>
          <Route path={RoutesName.HOME} Component={HomePage} />
          <Route path={RoutesName.STUDBOOK} Component={StudBookPage} />
          <Route path={RoutesName.AUCTIONS} Component={AuctionPage} />
          <Route path={RoutesName.SINGLE_AUCTION} Component={AuctionDetailsPage} />
          <Route path={RoutesName.AUCTION} element={<AuctionDetails key={'AuctionDetails'} toast={toast} />} />
          <Route path={RoutesName.OWNER_DETAILS} Component={OwnerDetailsPage} />
          <Route path={RoutesName.HORSE_DETAILS} Component={HorseDetailsPage} />
          <Route path={RoutesName.HORSE_MARKET_PROFILE} Component={HorseMarketProfile} />
          <Route path={RoutesName.LOGIN} Component={LoginPage} />
          <Route path={RoutesName.LOGIN_UAE_PASS} Component={LoginUaePassPage} />
          <Route path={RoutesName.UAE_PASS_OTP} Component={LoginUaePassPageOTP} />
          <Route path={RoutesName.REGISTER} Component={RegisterPage} />
          <Route path={RoutesName.HORSE_AUCTION} Component={HorseProfile} />
          <Route path={RoutesName.BIDDING} Component={BiddingPage} />
          <Route path={RoutesName.FULL_SCREEN_BIDDING} element={<LiveBiddingScreen />} />
          <Route path={RoutesName.HYBRID_BIDDING} element={<HybridBiddingPage toast={toast} />} />
          <Route path={RoutesName.PROFILE}
            element={
              <PrivateRoute>
                <OwnerProfile />
              </PrivateRoute>
            }
          />
          <Route path={RoutesName.HORSE_MARKET} Component={HorseMarket} />
          <Route path={RoutesName.SHOWS} Component={Shows} />
          <Route path={RoutesName.SHOW_DETAILS} Component={ShowDetails} />
          <Route path={RoutesName.FORGET_PASSWORD} Component={ForgetPasswordPage} />
          <Route path={RoutesName.SINGLE_SERVICE} Component={SingleServicePage} />
          <Route path={RoutesName.SINGLE_POST} Component={SinglePost} />
          <Route path={RoutesName.ABOUT_US} Component={AboutUs} />
          <Route path={RoutesName.NEWS} Component={NewsPage} />
          <Route path={RoutesName.HORSE_SUPPLIES} Component={HorseSupplies} />
          <Route path={RoutesName.SINGLE_SUPPLIER} Component={SingleSupplier} />
          <Route path={RoutesName.JUDGES_PAGE} Component={JudgesPage} />
          <Route path={RoutesName.PRESIDENT_WORD} Component={PresidentWord} />
          <Route path={RoutesName.LIBRARY_PAGE} Component={LibraryPage} />

          <Route
            path={RoutesName.HORSE_TRANSPORT_COMPANIES}
            Component={HorseTransportCompanies}
          />
          <Route
            path={RoutesName.SINGLE_TRANSPORT_COMPANY}
            Component={SingleTransportCompany}
          />
          <Route path={RoutesName.HORSE_HOSPITALS} Component={HorseHospitals} />
          <Route path={RoutesName.SINGLE_HOSPITAL} Component={SingleHospital} />
          <Route
            path={RoutesName.EQUESTRIAN_CENTERS_CLUBS}
            Component={EquestrianCentersClubs}
          />
          <Route
            path={RoutesName.SINGLE_EQUESTRIAN_CENTERS_CLUBS}
            Component={SingleEquestrianCentersClubs}
          />
          <Route path={RoutesName.CONTACT_US} Component={ContactUs} />
          <Route path={RoutesName.SERVICES} Component={ServicesPage} />
          <Route path={RoutesName.ORG_CHART} Component={OrgChartPage} />
          <Route path={RoutesName.WAHO_CONFERENCE} Component={WahoConference} />
          <Route path="/m-wahoconference" Component={WahoConference} />
          <Route path={RoutesName.SHOW_ENTRY_CARD} Component={ShowEntryCard} />
          <Route path={RoutesName.CALENDAR} Component={CalendarPage} />
          <Route path={RoutesName.ADD_EARLY_YEARLING_HORSE} element={<AddFoalHorse key={'add foal Horse'} toast={toast} />} />
          <Route
            path={RoutesName.SHOW_ENTRY_DETAILS}
            element={
              <PrivateRoute>
                <ShowEntryDetails key={'ShowEntryDetails'} toast={toast} />
              </PrivateRoute>
            } />
          <Route path={RoutesName.ADD_REGISTER_HORSE} Component={AddRegisterHorse} />
          <Route path={RoutesName.SHOW_ENTRY_CONFLICT} Component={ShowEntryConflict} />
          <Route path={RoutesName.COURSES} Component={CoursesNewPage} />
          <Route path={RoutesName.COURSE_DETAILS} element={<CoursesPage key={'courseDetails'} />} />
          <Route path={RoutesName.COURSE_ENROLLMENT} element={<CourseEnrollment key={'courseEnrollment'} toast={toast} />} />
          <Route path={RoutesName.COURSE_ENROLLMENT_DATE} element={<CourseEnrollmentDate key={'courseEnrollmentDate'} toast={toast} />} />
          <Route path={RoutesName.SPONSORS_PAGE} Component={SponsersPage} />
          <Route
            path={RoutesName.SHOW_ENTRY_TOTAL_REGISTERED_HORSES}
            Component={ShowEntryTotalRegisteredHorses}
          />
          <Route
            path={RoutesName.SHOW_ENTRY_PARTICIPANTS_REQUEST}
            Component={ShowEntryParticipantsRequest}
          />
          <Route
            path={RoutesName.SHOW_ENTRY_SUBMISSION_SUCCESSFUL}
            Component={ShowEntrySubmissionSuccessful}
          />
          <Route path={RoutesName.GALLERY} Component={GalleryPage} />
          <Route path={RoutesName.ALBUM_DETAILS} Component={AlbumPage} />
          <Route path={RoutesName.WAHO_TROPHY} Component={WahoTrophy} />
          <Route path={RoutesName.BOOK_TABLE} Component={BookTable} />
          <Route path={RoutesName.ADS_BOOK_TABLE} element={<BookTable isAds={true} />} />
          {/* <Route path={RoutesName.OPEND_EVENTS} element={<OpendBooking key="events" />} />
          <Route
            path={RoutesName.OPEND_ADS}
            element={<OpendBooking isAds={true} key="ads" />}
          /> */}
          <Route path={RoutesName.OPEND_ADS} element={<OpendBooking key="events" />} />
          <Route
            path={RoutesName.OPEND_EVENTS}
            element={<OpendBooking isAds={true} key="ads" />}
          />
          <Route path={RoutesName.SHOWS_CATEGORIES} element={<ShowsCategories key={RoutesName.SHOWS_CATEGORIES} ShowsCategoriesID={ShowsCategoriesID} />} />
          <Route path={RoutesName.NONE_ECAHO_SHOWS_CATEGORIES} element={<ShowsCategories key={RoutesName.NONE_ECAHO_SHOWS_CATEGORIES} hasHTML={true} ShowsCategoriesID={NoneEcahoShowsCategoriesID} />} />
          <Route path={RoutesName.AUCTION_ENTRY_CARD} Component={AuctionEntryCard} />
          <Route path={RoutesName.EAHS_AWARD} Component={AwardPage} />
          <Route path={RoutesName.OPEN_APP_OR_STORE} Component={OpenApp} />
          <Route
            path={RoutesName.AUCTION_ENTRY_TOTAL_REGISTERED_HORSES}
            Component={Auctionentrytotalregisteredhorses}
          />
          <Route
            path={RoutesName.AUCTION_ENTRY_SUBMISSION_SUCCESSFUL}
            Component={AuctionEntrySubmissionSuccessful}
          />
          <Route
            path={RoutesName.BOOKING_SUCCESSFUL}
            Component={BookingSubmissionSuccessful}
          />
          <Route
            path={RoutesName.REQUEST_HORSE_OWNERSHIP_TRANSFER_SELLER}
            Component={RequestHorseOwnershipTransferSeller}
          />
          <Route
            path={RoutesName.SERVICES_REQUESTS_PAYMENT_SUCCESSFUL}
            Component={ServicesRequestsPaymentSuccessful}
          />
          <Route path={RoutesName.EDUCATIONAL_COURSES} Component={EducationalPage} />
          <Route path={RoutesName.ADD_INTERNATIONAL_HORSE} element={<AddInternationalHorse key={'addInternationalHorse'} toast={toast} />} />
          <Route path={RoutesName.SHOW_ENTRY_CHECKOUT_PAGE} element={<ShowEntryCheckoutPage key={'ShowEntryCheckoutPage'} toast={toast} />} />
          <Route
            path={RoutesName.SINGLE_TERMS_AND_CONDITIONS_SHOW_PAGE}
            Component={SingleTermsAndConditionsShowPage}
          />
          <Route
            path={RoutesName.ADD_ORGANIZER_REQUEST}
            Component={AddOrganizerRequest}
          />
          <Route path={RoutesName.SHOW_CATALOG} Component={ShowCatalog} />
          <Route path={RoutesName.NOT_FOUND_404} Component={ComingSoon} />
          <Route path={RoutesName.NOT_AUTHORIZED_403} key={'not Auth'} element={<ComingSoon key={'not authrized'} text="web.notAuthrized" defaultText="Not Authrized" />} />
          <Route path={RoutesName.LIVE_EVENT} Component={LiveStream} />
          <Route
            path={RoutesName.REQUEST_COVERING_CERTIFICATE}
            Component={RequestCoveringCertificate}
          />
          <Route
            path={RoutesName.REQUEST_EMBRYO_OOCYTE_TRANSFER_PERMIT}
            Component={RequestEmbryoOocyteTransferPermit}
          />
          <Route
            path={RoutesName.REQUEST_EMBRYO_TRANSFER_RIGHT_PURCHASE_AGREEMENT}
            Component={RequestEmbryoTransferRightPurchaceAgreement}
          />
          <Route
            path={RoutesName.REQUEST_REGISTERING_NEW_ARABIAN_HORSE_FOAL}
            Component={RequestRegisteringNewArabianHorseFoal}
          />
          <Route
            path={RoutesName.REQUEST_OWNED_HORSES_CERTIFICATE}
            Component={RequestForOwnedEAHSRegisteredHorsesCertificate}
          />
          <Route
            path={RoutesName.REQUEST_REGISTER_ARABIAN_HORSE_STUD}
            element={<RequestForRegistrationOfAnArabianHorseStud toast={toast} />}
          />
          <Route
            path={RoutesName.REQUEST_UPDATE_HORSE_DATA}
            Component={RequestToUpdateArabianHorseData}
          />
          <Route
            path={RoutesName.REQUEST_HORSE_DEATH_DECLARATION}
            Component={RequestToDeclarationOfArabianHorseDeath}
          />
          <Route
            path={RoutesName.INACTIVE_HORSE_REGISTRATION_REQUEST}
            Component={InactiveHorseRegistrationRequest}
          />
          <Route
            path={RoutesName.REQUEST_RACING_NAME_IMPORTED_HORSE}
            Component={RequestToAddARacingNameForAnImportedArabianHorse}
          />
          <Route
            path={RoutesName.REQUEST_PASSPORT_DUPLICATE_DAMAGED}
            Component={ReqestForIssuingAnArabianHorsePassportDuplicateDamaged}
          />
          <Route
            path={RoutesName.IMPORT_HORSE_FROZEN_SEMEN}
            Component={ImportHorseFrozenSemen}
          />
          <Route
            path={RoutesName.IMPORT_HORSE}
            Component={ImportHorse}
          />
          <Route
            path={RoutesName.GENETIC_DISORDER_TESTING}
            Component={GeneticDisorderTesting}
          />
          <Route
            path={RoutesName.REQUEST_SEMEN_CERTIFICATE}
            Component={RequestSemenCertificate}
          />
          <Route path={RoutesName.EXPORT_HORSE} element={<ExportHorse key={'ExportHorse'} toast={toast} />} />

          <Route
            path={RoutesName.CANCEL_EXPORT_HORSE}
            Component={CancelExportHorse}
          />

          <Route
            path={RoutesName.EXPORT_HORSE_SEMEN}
            Component={ExportHorseSemen}
          />

          <Route
            path={RoutesName.PRESS_COVERAGE_REQUEST}
            Component={PressCoverageRequest}
          />
          {/* <Route
            path="/m-opend-events"
            element={<OpendBooking isMobileWebView={true} isAds={true} />}
          />
          <Route
            path="/m-opend-ads"
            element={<OpendBooking  isMobileWebView={true} />}
          /> */}
          <Route
            path="/m-opend-ads"
            element={<OpendBooking isMobileWebView={true} isAds={true} />}
          />
          <Route
            path="/m-opend-events"
            element={<OpendBooking isMobileWebView={true} />}
          />
          <Route path="/m-book-table" element={<BookTable />} />
          <Route
            path="/m-ads-book-table"
            element={<BookTable isAds={true} />}
          />
          <Route
            path={RoutesName.SHOW_PARTICIPATE}
            element={
              <PrivateRoute>
                <ShowParticipatePage key={'participation Page'} toast={toast} />
              </PrivateRoute>
            } />
          <Route
            path={RoutesName.AUCTION_PARTICIPATE}
            element={
              <PrivateRoute>
                <AucitonEntryParticipate key={'participation Page'} toast={toast} />
              </PrivateRoute>
            }
          />
          <Route
            path={RoutesName.AUCTION_ENTRY_CHECKOUT_PAGE}
            element={<AuctionEntryCheckoutPage key={'AuctionEntryCheckoutPage Page'} toast={toast} />} />
          <Route
            path={RoutesName.CHULIBPAGE}
            element={<ChulibPage key={'CHULIB Page'} toast={toast} />} />
          <Route
            path={RoutesName.SEMENMARKET}
            element={<SemenMarketListPage key={'SEMENMARKET'} toast={toast} />} />
          <Route
            path={RoutesName.OWNERSSERVICEFORM}
            element={<OwnerServicesForm key={'OWNERSSERVICEFORM'} toast={toast} />} />
          <Route
            path={RoutesName.SEMENDETAILS}
            element={<SemenDetails key={'SEMENDETAILS'} toast={toast} />} />
          <Route
            path={RoutesName.SEMENCHECKOUT}
            element={<SemenCheckout key={'SEMENCHECKOUT'} toast={toast} />} />
          <Route
            path={'/fontsCompetitionRegistration'}
            element={<FontCompetitionPage key={'OWNERSSERVICEFORM'} />} />
          <Route
            path={'/digitalCatalog'}
            element={<DigitalCatalog key={'digitalCatalog'} />} />
        </Routes>
      </Layout>

    </Router>
  );
}

export default App;
